import React, { forwardRef } from "react";

import { Icon } from "../components/icon";

const InfoIcon = forwardRef<any, any>((props, ref) => (
  <Icon {...props} ref={ref}>
    <g clipPath="url(#clip0_1404_4217)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#0A78BF"
      />
      <g filter="url(#filter0_dd_1404_4217)">
        <path
          d="M9.19992 7.04008L9.19998 7.29838L9.19989 12.9617C9.19989 13.1272 9.0625 13.2646 8.89627 13.2654L7.09977 13.2653C6.93354 13.2646 6.79652 13.1276 6.79652 12.9621L6.79655 9.70256L6.79655 7.03967C6.79693 6.87306 6.93356 6.73642 7.0998 6.73643L8.89629 6.73645C9.06252 6.73645 9.19954 6.87347 9.19992 7.04008Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter1_dd_1404_4217)">
        <circle cx="7.98828" cy="4.25" r="1.25" fill="white" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_1404_4217"
        x="-1.20312"
        y="-0.26358"
        width="18.4023"
        height="22.5289"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1404_4217"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.14 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1404_4217"
          result="effect2_dropShadow_1404_4217"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1404_4217"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dd_1404_4217"
        x="-1.26172"
        y="-4"
        width="18.5"
        height="18.5"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1404_4217"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.14 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1404_4217"
          result="effect2_dropShadow_1404_4217"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1404_4217"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_1404_4217">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </Icon>
));

export { InfoIcon };
